import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Button, DefaultTable } from 'twyne-new.ui';

import TextTruncated from '@Components/TextTruncated';
import ObjectModal from '@Components/modals/ObjectModal';
import { formatDateTime } from '@Utils/index';

import store from '../../../stores/inquiry'
import inquireStore from '../../../stores/inquiry'

import { fallback, getUrlLink, formatBool, formatMoney } from './utils'
import { Search } from 'lucide-react';

const propTypes = {
  data: PropTypes.array,
};

export default function ImpressionResult({ data }) {
  return <DefaultTable keyField="id"
    data={data || []}
    columns={[
      {
        dataField: 'created_at',
        text: 'Created At',
        formatter: formatDateTime,
      },
      {
        dataField: 'pathUserProfileId',
        text: 'User Profile Id',
        formatter: cell => cell ? <Link to={`${getUrlLink('userProfile')}/${cell}`}>
          {store.pathUserProfile.objectsMapping[cell]?.getLabel() || cell}
        </Link> : 'Default',
      },
      {
        dataField: 'path_id',
        text: 'Path Id',
        formatter: cell => <Link to={`${getUrlLink('path')}/${cell}`}>
          {store.path.objectsMapping[cell]?.getLabel() || cell}
        </Link>,

      },
      {
        dataField: 'slotPosition',
        text: 'Slot Position',
        formatter: cell => cell + 1,
      },
      {
        dataField: 'page_id',
        text: 'Page Id',
        formatter: cell => <Link to={`${getUrlLink('page')}/${cell}`}>
          {store.page.objectsMapping[cell]?.getLabel() || cell}
        </Link>,
      },
      {
        dataField: 'partner_id',
        text: 'Partner Id',
        formatter: cell => <Link to={`${getUrlLink('publisher')}/${cell}`}>
          {store.publisher.objectsMapping[cell]?.getLabel() || cell}
        </Link>,
      },
      {
        dataField: 'completed',
        text: 'Completed',
        formatter: formatBool,
      },
      {
        dataField: 'Revenue',
        text: 'Revenue',
        formatter: formatMoney,
      },
      {
        dataField: 'page_id',
        text: 'Survey',
        formatter: (pageId, { tcpa }) => {
          const page = inquireStore.getPage(pageId)
          const { tcpaquestion: surveysQuestion } = page.type === 'tcpa-question' && JSON.parse(page.integrationData) || {}
          if (!surveysQuestion) {
            return null
          }
          return <Survey answer={tcpa?.answer} cfid={tcpa?.field || ''} question={surveysQuestion} />
        },
      },
      {
        dataField: '',
        text: '',
        formatter: (_, row) => {
          const ButtonOpen = ({ id, handleToggle }) => <Button variant='ghost' color='accent' id={id} onClick={handleToggle}>
            <Search size={16} />
          </Button>

          const impressionData = Object.entries(row || {})
          return <ObjectModal id="impression-modal" button={ButtonOpen} title="Impression Data" data={impressionData} />
        },
      },
    ]}
    bordered={false}
    noDataIndication={() => 'No content to show.'}
  />
}

ImpressionResult.propTypes = propTypes

function Survey({ answer, cfid, question: { question, answers: options } }) {
  return <div>
    {cfid && <>
      <span>Key: cf_{cfid}</span> <br />
    </>}
    Question: <TextTruncated id={`reg-${cfid}`} maxLength={50} >
      {question}
    </TextTruncated>
    Your answer: {fallback(answer)} <br />
  </div>
}
